<template>
  <div>
    <v-row>
      <v-col md="6">
        <v-autocomplete
          :label="InputLabel"
          clearable
          outlined
          v-model="fontListener"
          :loading="loading"
          loader-height="5"
          :messages="loadingArticleMsg"
          :items="fontList"
        />
      </v-col>
    </v-row>

  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'

export default {
  props: {
    selectedFont: {
      type: String,
      default: ''
    },
    InputLabel: {
      type: String,
      default: 'Default Main Font'
    }
  },

  data () {
    return {
      search_query: '',
      loading: false,
      loading_message: 'Fetching Data',
      article_options: []
    }
  },
  methods: {
    ...mapActions({
      getFontList: 'googleFonts/getList'
    }),
    async fetchFontList () {
      this.loading = true
      await this.getFontList()
      this.loading = false
    }
  },

  computed: {
    ...mapState({
      fontList: state => state.googleFonts.list
    }),

    fontListener: {
      get () {
        return this.selectedFont
      },
      set (val) {
        this.$emit('update:selectedFont', val)
      }
    },
    loadingArticleMsg () {
      let message = ''
      if (this.loading === true) {
        message = 'searching article. . .'
      }
      return message
    }
  },
  created () {
    this.fetchFontList()
  }
}
</script>

<style Scoped>
.header-btns {
  color: #df4661;
  cursor: pointer;
}
</style>
